import ApiService from '@/services/api.service'

const DCSService = {
    listing(parameter) {
            const params = {}
            if(parameter.Status != 'All'){
                params.SearchCriteria = parameter.SearchCriteria,
                params.PageSize = parameter.PageSize,
                params.PageNumber = parameter.PageNumber
                params.MonthList = parameter.MonthList
                params.YearList = parameter.YearList
            }else{
                params.SearchCriteria = parameter.SearchCriteria,
                params.PageSize = parameter.PageSize,
                params.PageNumber = parameter.PageNumber
                params.MonthList = parameter.MonthList
                params.YearList = parameter.YearList       
            }
            return ApiService.getWithArray('/DCSClaim',params); 
    },
    populateNotes(data){
        return ApiService.post("/DCSClaim/notes", data);
    },

    populateNotes2(year,month){     
        return ApiService.get(`/DCSClaim/Notes/${year}:${month}`);
    },

    getAllNotes(){
        return ApiService.get("/DCSClaim/Notes")
    },

    dcsReview(data){
        return ApiService.post("/DCSClaim/review", data);
    },

    dcsReviewResult(data){
        return ApiService.post("/DCSClaim/ReviewResult", data);
    },

    dcsProduction(data){
        return ApiService.post("/DCSClaim/production", data);
    },

    dcsProductionResult(data){
        return ApiService.post("/DCSClaim/ProductionResult", data);
    },

    dcseMail(data){
        return ApiService.post("/DCSClaim/email", data);
    },

    tableControl(data){
        return ApiService.post("/DCSClaim/tableControls", data);
    },

    dcsDelete(Year,Month,Version){       
         return ApiService.delete(`/DCSClaim/${Year}:${Month}:${Version}`)
    },

    dcsdownload(GroupCreationID,Ver){  
        return ApiService.get(`/DCSClaim/exportcsv?GroupCreationID=${GroupCreationID}&Version=${Ver}`); 
    },

    dcsException(data){
        return ApiService.getData(`/DCSClaim/exceptions?GroupCreationID=${data.groupCreationID}&Mode=${data.mode}&Version=${data.version}`);
    },

    getContentCSV(GroupCreationID,Ver){
        return ApiService.get(`/DCSClaim/${GroupCreationID}:${Ver}`);   
    },

    getDCSReport(parameter) {
        const params = {}
        params.SearchCriteria = parameter.SearchCriteria
     //   params.PageSize = parameter.PageSize
      //  params.PageNumber = parameter.PageNumber
        params.Month = parameter.Month
        params.Year = parameter.Year
        params.PatientCodeList = parameter.PatientCodeList
        params.NoteTypeList = parameter.NoteTypeList
        params.StatusCode = parameter.Status
        console.log(params)
        return ApiService.getWithArray(`/DCSDataUpload`, params)
    },

    uploadDCSReport(data) {
        return ApiService.post("/DCSDataUpload/upload", data)
    },

    monitorUpload(parameter) {
        return ApiService.getWithArray(`/DCSDataUpload/monitor`, parameter)
    },

    CanceluploadDCS(parameter) {
        return ApiService.post("/DCSDataUpload/cancel", parameter)
    },
}

export default DCSService;